/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserDeviceResponse } from '../models/UserDeviceResponse';
import type { UserDeviceUpdateRequest } from '../models/UserDeviceUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileDevicesService {
    /**
     * Delete a device
     * Delete a device owned by the authenticated mobile user
     * @param deviceId
     * @param xMobileAuth
     * @returns void
     * @throws ApiError
     */
    public static deleteMobileUserDevice(
        deviceId: string,
        xMobileAuth?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mobile/v1/devices/{device_id}',
            path: {
                'device_id': deviceId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update a device
     * Update a device owned by the authenticated mobile user
     * @param deviceId
     * @param requestBody
     * @param xMobileAuth
     * @returns UserDeviceResponse Successful Response
     * @throws ApiError
     */
    public static updateMobileUserDevice(
        deviceId: string,
        requestBody: UserDeviceUpdateRequest,
        xMobileAuth?: (string | null),
    ): CancelablePromise<UserDeviceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/mobile/v1/devices/{device_id}',
            path: {
                'device_id': deviceId,
            },
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
